import { GraphQLClient as Client } from 'graphql-request';

const internal_api = process.env.RAZZLE_internal_content_api_uri_base;
const public_api = process.env.RAZZLE_public_graphql_uri
  ? process.env.RAZZLE_public_graphql_uri
  : process.env.RAZZLE_content_api_uri_base;

export default function GraphQLClient(req, res) {
  const headers = req ? req.headers : {};
  const client = new Client(
    `${
      res && typeof internal_api !== 'undefined' ? internal_api : public_api
    }/graphql`,
    {
      headers: { ...headers },
      credentials: 'include'
    }
  );

  return client;
}
